import { render, staticRenderFns } from "./salonItem.vue?vue&type=template&id=117774c2&scoped=true&"
import script from "./salonItem.vue?vue&type=script&lang=js&"
export * from "./salonItem.vue?vue&type=script&lang=js&"
import style0 from "./salonItem.vue?vue&type=style&index=0&id=117774c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117774c2",
  null
  
)

export default component.exports